var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('AboutUsPgHeader'),_c('section',{staticClass:"form-full-width"},[_c('FormAboutUsPg',{attrs:{"loading":_vm.loading,"getAboutUsPg":_vm.getAboutUsPg},on:{"beforeUpdate":_vm.updateAboutUsPg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }